import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
type CountdownTimerProps = {
  label?: string;
  tone?: 'dark' | 'light';
};
export function CountdownTimer({
  label = 'This promotional price expires in',
  tone = 'dark'
}: CountdownTimerProps) {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  const shell = tone === 'dark' ? 'border-teal-400/30 bg-ink-900/70' : 'border-ink-900/10 bg-white';
  const labelColor = tone === 'dark' ? 'text-teal-200/80' : 'text-ink-600';
  const digitShell = tone === 'dark' ? 'bg-ink-800 text-white' : 'bg-ink-900 text-white';
  const units: Array<[string, number]> = [['HRS', hrs], ['MIN', mins], ['SEC', secs]];
  return <div className={`w-full rounded-2xl border px-4 py-4 ${shell}`} data-id="element-20" data-mp="1h12z03j6h3qv">
      <p className={`flex items-center justify-center gap-1.5 text-center text-[11px] font-bold uppercase tracking-[0.14em] ${labelColor}`} data-id="element-21" data-mp="123k8avmxwggs">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="1ur6bi2s99j34" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" role="timer" aria-live="off" data-id="element-23" data-mp="1utivelhkq3it">
        {units.map(([unit, value]) => <div key={unit} className="flex flex-col items-center gap-1" data-id="element-24" data-mp="1l24ymlh0bhtd">
            <span className={`min-w-[3.25rem] rounded-xl px-2 py-2 text-center font-display text-3xl font-bold tabular-nums sm:min-w-[3.75rem] sm:text-4xl ${digitShell}`} data-id="element-25" data-mp="1q06hp6efnh4u">
              {pad(value)}
            </span>
            <span className={`text-[10px] font-bold uppercase tracking-[0.16em] ${tone === 'dark' ? 'text-white/45' : 'text-ink-500/70'}`} data-id="element-26" data-mp="2ihity7l4my7y">
              {unit}
            </span>
          </div>)}
      </div>
    </div>;
}